export class PersonDTO {
  idPerson: number;
  dniPerson: string;
  namePerson: string;
  idStatus: number;

  personType: string;
  nameStatus: string;
  observation: string;
  motivo?: string;
  sinisterCount: number;
  sinisterDate: string;
  country?: string;
  identificationType?: string;
  registrationArea?: string;
  subArea?: string;
  alertType?: string;
  systemLocked?: string;
  registerType?: string;
  isTemporarilyUnlocked: boolean;
  unlockedUntil: string;
  unlockReason: string;

  countryIso?: string;
}
